type Segment = {
  flex: number;
  color: string;
};

type Props = {
  segments: Segment[];
  totalPercent: number;
};

export function SegmentedProgressBar({ segments, totalPercent }: Props) {
  return (
    <div className="h-2 bg-gray-100 rounded-full overflow-hidden mb-[16px]">
      <div
        className="h-full flex overflow-hidden rounded-full transition-all duration-300"
        style={{ width: `${Math.min(100, totalPercent)}%` }}
      >
        {segments.map((seg) => (
          <div key={seg.color} style={{ flex: seg.flex, backgroundColor: seg.color }} />
        ))}
      </div>
    </div>
  );
}
